import React, { useEffect, useRef } from 'react';
import { FocusContext, useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import clsx from 'clsx';
import Button from '@smart-tv/components/button/button';
import Typography from '@smart-tv/components/typography';
import { Props } from './error-dialog';
import styles from './error-dialog.module.scss';

export const ErrorDialogContent = (props: Props) => {
  const { title, message, primaryButton, secondaryButton } = props;

  const hasFocusedBefore = useRef(false);

  const { ref, focusSelf, focusKey, hasFocusedChild } = useFocusable({
    isFocusBoundary: true,
    focusable: false,
    trackChildren: true
  });

  useEffect(() => {
    focusSelf();
  }, [focusSelf]);

  //keeps focus from being lost while dialog is open
  useEffect(() => {
    if (hasFocusedChild) {
      hasFocusedBefore.current = true;
    } else if (hasFocusedBefore.current) {
      focusSelf();
    }
  }, [hasFocusedChild, focusSelf]);

  return (
    <FocusContext.Provider value={focusKey}>
      <div className={styles['error-dialog']} ref={ref}>
        <Typography className={styles['error-dialog--title']} variant="h1" component="div">
          {title}
        </Typography>
        <Typography>{message}</Typography>
        {primaryButton && (
          <Button
            focusKey="error-dialog-primary-button"
            className={clsx(
              styles['error-dialog--button'],
              styles['error-dialog--button--primary']
            )}
            onClick={primaryButton.onClick}
          >
            {primaryButton.label}
          </Button>
        )}
        {secondaryButton && (
          <Button
            focusKey="error-dialog-secondary-button"
            className={clsx(
              styles['error-dialog--button'],
              styles['error-dialog--button--secondary']
            )}
            onClick={secondaryButton.onClick}
          >
            {secondaryButton.label}
          </Button>
        )}
      </div>
    </FocusContext.Provider>
  );
};

export default ErrorDialogContent;
